import { FileImageOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import React, { useState } from "react";

type SingleImageWithFallbackProps = {
  url: string;
  alt?: string; // Add optional alt text prop
  className?: string; // Allow passing custom classes
};

const SingleImageWithFallback: React.FC<SingleImageWithFallbackProps> = ({
  url,
  alt = "Post content", // Default alt text
  className, // Removed default value
}) => {
  const [imageError, setImageError] = useState(false);

  if (imageError) {
    return (
      <div className="w-full min-h-[200px] flex items-center justify-center bg-antd-colorBgContainer text-antd-colorTextSecondary">
        <Tooltip title="Media failed to load">
          {/* Using FileImageOutlined as the fallback */}
          <FileImageOutlined style={{ fontSize: "48px" }} />
        </Tooltip>
      </div>
    );
  }

  return (
    <img
      src={url}
      alt={alt}
      className={className}
      onError={() => setImageError(true)}
    />
  );
};

export default SingleImageWithFallback;
